import { app } from "modular-openscriptjs";
import { authenticated, fireEvent, afterAuth, inform, redirect, empty } from "../helpers";
import { STRINGS, gc, uc } from "../declarations";
import { Preferences } from "@capacitor/preferences";

export class Middleware {
	/**
	 * Ensures the user is authenticated and has filled in their phone number
	 * @param {function} next
	 * @returns {any}
	 */
	auth(next) {
		if (authenticated()) {
			if (typeof next === "undefined") {
				return this;
			} else if (typeof next === "function") {
				return next();
			} else {
				return true;
			}
		}

		let url = location.pathname;
		Preferences.set({ key: "redirect-url-after-auth", value: url });

		inform("Please log in to continue", STRINGS.ERROR);
		app("router").to("user.login");
		return null;
	}

	/**
	 * Ensures the user has completed their profile (filled in their phone number)
	 * @param {function} next
	 * @returns {any}
	 */
	profileCompletion(next) {
		const route = app("router");
		const user = gc.user.value;

		if (!user?.phone) {
			if (!route.is("user.edit-profile")) {
				let url = location.pathname;
				Preferences.set({ key: "redirect-url-after-auth", value: url });
				inform("Please complete your profile details (fill in your phone number) to continue", STRINGS.WARNING);
				route.to("user.edit-profile");
				return null;
			}
		}

		if (typeof next === "undefined") {
			return this;
		} else if (typeof next === "function") {
			return next();
		} else {
			return true;
		}
	}

	/**
	 * Ensures the user has at least one delivery address
	 * @param {function} next
	 * @returns {any}
	 */
	deliveryAddress(next) {
		if (!empty(uc.addresses.value)) {
			if (typeof next === "undefined") {
				return this;
			} else if (typeof next === "function") {
				return next();
			} else {
				return true;
			}
		}

		inform("Please add a delivery address to proceed", STRINGS.INFO);
		// Open the address form if no address exists
		app("broker").send(app("$e").deliveryAddress.needs.addressForm);
		return null;
	}
}
